
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import Btn from "../../components/shared/button/Btn"
import { showModal } from "../../features/modal/modalSlice"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner"
import Pagination from "../../components/shared/Pagination"
import { useState } from "react"
import InputText from "../../components/shared/input/new/InputText"
import locationData from "../../utils/locationData/locationOptions"
import InputCityTown from "../../components/shared/input/new/InputCityTown"
import { getCoopMembers, getCoopTopluUyeExcel } from "../../features/uyelerAraclar/uyelerAraclarSlice"
import UyelerTable from "../../components/shared/kooperatifUyelerAraclar/UyelerTable"

const Container = styled.div`
    width: 100%;
    height: auto;

    .wrapper{
        width: 100%;
        padding: 30px;
        min-height: 500px;

        .top-container{
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            gap: 20px;
            flex-direction: column;
            .filter-container{
                display: flex;
                gap: 20px;
            }

            .btn-container{
                display: flex;
                gap: 20px;
            }
            

        }

        .content{
            display: flex;
            flex-direction: column;
            align-items: center;






            .titles{
                width: 100%;
                display: grid;
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
                gap: 15px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                text-align: center;
            }
        }
    }
    
`

const Uyeler = () => {

    const dispatch = useDispatch()
    const { coopMemberList, coopMemberListCount, isLoadingGetCoopExcel } = useSelector(state => state.uyelerAraclar)
    const itemsPerPage = 10;
    const totalPages = Math.ceil(coopMemberListCount / itemsPerPage);

    const [currentPage, setCurrentPage] = useState(1);
    const [adSoyadUnvan, setAdSoyadUnvan] = useState("")
    const [firmaAdi, setFirmaAdi] = useState("")
    const [tcNo, setTcNo] = useState("")
    const [location, setLocation] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
 

    useEffect(() => {
        dispatch(getCoopMembers({currentPage, adSoyadUnvan, IlIlce: location?.location, tcNo, phoneNumber: phoneNumber?.trim()?.replace(/^0+/, '') }))
    },[currentPage, adSoyadUnvan, tcNo, phoneNumber,location?.location])

    const handleClearAllInput = () => {
        setAdSoyadUnvan("")
        setTcNo("")
        setPhoneNumber("")
        setLocation("")
}

    //! 0 hepsi
    //! 1 güncelleyenler
    //! 2 güncellemeyenler

  return (
    <Container>
        <PageTopTitle title={"Üyeler"}/>
        <div className="wrapper">
            <div className="top-container">
                <div className="filter-container">
                    <InputText data={phoneNumber} setData={(e)=> setPhoneNumber(e.target.value)} labelText="Telefon" inputWidth={"140px"} name={"phoneNumber"}/>
                    <InputText data={adSoyadUnvan} setData={(e)=> setAdSoyadUnvan(e.target.value)} labelText="Ad Soyad/Unvan" inputWidth={"160px"} name={"adSoyadUnvan"}/>
                    <InputText data={tcNo} setData={(e)=> setTcNo(e.target.value)} labelText="TC No" inputWidth={"140px"} name={"tcNo"}/>
                    <InputText data={firmaAdi} setData={(e)=> setFirmaAdi(e.target.value)} labelText="Firma Adı" inputWidth={"160px"} name={"firmaAdi"}/>
                    <InputCityTown data={location?.location || ""} setData={setLocation} initialOptions={locationData} labelText={"İlçe / İl"} inputWidth={"220px"} name={"ililce"}/>
                    <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"140px"} handleClick={handleClearAllInput}>Temizle</Btn>
                </div>
                <div className="btn-container">
                    <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"140px"} handleClick={() => dispatch(getCoopTopluUyeExcel())}>{isLoadingGetCoopExcel ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Excel Çıktısı Al"}</Btn>
                    <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"140px"} handleClick={() => dispatch(showModal("uyelerVeAraclarUyeEkle"))}>Üye Ekle</Btn>
                    <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"140px"} handleClick={() => dispatch(showModal("kooperatifTopluUyeEkle"))}>Toplu Üye Ekle</Btn> 
                </div>
            </div>

            <div className="content">
                <UyelerTable list={coopMemberList}/>

                <Pagination totalPages={totalPages} handleClick={setCurrentPage} currentPage={currentPage}/>
            </div>
        </div>
    </Container>
  )
}


export default Uyeler